import React from "react";
import Grid from "@mui/material/Grid2";
import { useTranslate } from "@refinedev/core";

import { Form } from "@shared/components";
import { useMediaTypeOptions } from "@shared/options";

export const BookCategoryListFilters = React.memo(() => {
  const translate = useTranslate();

  const { getMediaTypeOptions } = useMediaTypeOptions();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="search"
          label={translate("book_category_admin.filters.search")}
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Select
          name="type"
          label={translate("v1/book_admin.filters.type")}
          options={getMediaTypeOptions()}
          fullWidth
        />
      </Grid>
    </Grid>
  );
});
